import { useEffect } from "react";

import hotToast from "react-hot-toast";
import reactToText from "react-to-text";

import {
  NotificationVariant,
  TOAST_VARIANTS,
  ToastParams,
  TrackNotificationArgs,
} from "src/design-system/Toast/constants";
import { Toast } from "src/design-system/Toast/Toast";
import {
  tracker,
  trackingEvents,
} from "src/instrumentation/customTrackingEvents";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const useTrackNotification = ({
  variant,
  title,
  description,
}: TrackNotificationArgs) => {
  const { orgId } = useParamsDecode<{ orgId?: string }>();
  const descriptionText = reactToText(description);

  useEffect(() => {
    tracker.emit(
      trackingEvents.authoringPopupNotification({
        organization_id: orgId ? orgId : "unknown-org",
        type: variant,
        message: descriptionText,
        title: title,
      }),
    );
  }, [orgId, variant, descriptionText, title]);
};

export const createToast =
  (variant: NotificationVariant) =>
  ({ id, duration, ...params }: ToastParams): string => {
    const isInfinite =
      duration === null ||
      params.isDismissible === false ||
      (variant === TOAST_VARIANTS.LOADING && duration === undefined);
    return hotToast.custom(
      (t) => <Toast toastInstance={t} variant={variant} {...params} />,
      {
        id,
        duration: isInfinite ? Infinity : duration,
      },
    );
  };

export const toastActions = {
  success: createToast(TOAST_VARIANTS.SUCCESS),
  failure: createToast(TOAST_VARIANTS.ERROR),
  loading: createToast(TOAST_VARIANTS.LOADING),
  default: createToast(TOAST_VARIANTS.DEFAULT),
  warning: createToast(TOAST_VARIANTS.WARNING),
  multi: createToast(TOAST_VARIANTS.DEFAULT),
  dismiss: (id: string) => hotToast.dismiss(id),
};
